import PdfCa from '../pdf_ca';
import React, { useMemo } from 'react';
import CaText from '../ca_text';
import { Form } from 'react-bootstrap-5';
import PropTypes from 'prop-types';
import { post } from 'helpers/api';

export default function CaContainer({ caData, caFields, setCaFields, trackViewedCaPath }) {
  
  React.useEffect(() => {
    const pathName = window.location.pathname;
    const hasViewed = sessionStorage.getItem(`viewed_ca_${pathName}`);

    if (!hasViewed) {
      post(trackViewedCaPath).then(() => {
        sessionStorage.setItem(`viewed_ca_${pathName}`, true);
      });
    }
  }, []);

  function changeCaChecked(newValue) {
    setCaFields({ ...caFields, checked: newValue });
  }

  function fileUploaded(uploadedFile) {
    setCaFields({ ...caFields, uploadedFile: uploadedFile });
  }

  if (caData.filePath) {
    return (
      <PdfCa
        caFilePath={caData.filePath}
        caType={caData.type}
        uploadedFile={caFields.uploadedFile}
        onFileUploaded={fileUploaded}
      />
    );
  }

  return (
    <TextCa
      caChecked={caFields.checked}
      caText={caData.text}
      digitalSignFilePath={caData.digitalSignFilePath}
      onCaChecked={changeCaChecked}
    />
  );
}

function TextCa({ caChecked, caText, digitalSignFilePath, onCaChecked }) {
  const pdfPreview = useMemo(() => {
    if (!digitalSignFilePath) return null;

    const url = new URL(digitalSignFilePath);
    url.hash = 'toolbar=0&navpanes=0&scrollbar=0&zoom=FitH';
   
    return <iframe height="500px" src={url.toString()} width="100%"/>;
  }, [digitalSignFilePath]);

  return (
    <React.Fragment>
      {pdfPreview}
      {caText.length > 0 && <CaText caText={caText}/>}
      <Form.Group className="mb-4">
        <Form.Check
          checked={caChecked}
          id="email-ca"
          label="Email me a copy of this CA"
          name="email_ca"
          type="checkbox"
          onChange={e => onCaChecked(e.target.checked)}
        />
      </Form.Group>
    </React.Fragment>
  );
}

CaContainer.propTypes = {
  caData: PropTypes.shape({
    digitalSignFilePath: PropTypes.string,
    text: PropTypes.string,
    type: PropTypes.string,
    filePath: PropTypes.string,
  }).isRequired,
  caFields: PropTypes.object.isRequired,
  setCaFields: PropTypes.func.isRequired,
  trackViewedCaPath: PropTypes.string.isRequired,
};

TextCa.propTypes = {
  caChecked: PropTypes.bool.isRequired,
  caText: PropTypes.string.isRequired,
  digitalSignFilePath: PropTypes.string,
  onCaChecked: PropTypes.func.isRequired,
};
